import { useSelector } from 'react-redux'

import {
  GiftIcon,
  HouseIcon,
  MedalIcon,
  TicketIcon,
  UserIcon,
} from '@phosphor-icons/react'

import routes from 'core/routes'

import { BtnTabBar, Content, Header, TabBar } from 'modules/console/components'

import { TRootReducer } from 'store'

function ConsoleLayout({ children, showTabBar, onAvatarClick }: any) {
  const { user, app } = useSelector((state: TRootReducer) => state)

  return (
    <>
      <Header
        user={{
          name: user.attributes.name?.split(' ')[0],
          avatar: user.attributes?.picture,
          phone: user.attributes.phone_number.slice(2),
          onClick: onAvatarClick,
        }}
      />

      <Content>{children}</Content>

      <TabBar show={showTabBar}>
        <BtnTabBar to={`/${app.key + routes.app.console.home}`}>
          <HouseIcon size={24} />
        </BtnTabBar>

        <BtnTabBar to={`/${app.key + routes.app.console.scores}`}>
          <MedalIcon size={24} />
        </BtnTabBar>

        <BtnTabBar to={`/${app.key + routes.app.console.rewards}`}>
          <GiftIcon size={24} />
        </BtnTabBar>
        <BtnTabBar to={`/${app.key + routes.app.console.sweepstakes}`}>
          <TicketIcon size={24} />
        </BtnTabBar>

        <BtnTabBar to={`/${app.key + routes.app.console.userProfile}`}>
          <UserIcon size={24} />
        </BtnTabBar>
      </TabBar>
    </>
  )
}

export { ConsoleLayout }
